import { useEffect } from "react";

/**
 * `KIT-TOAST-D2` part 2 (D2 `app.js:167`): a bank toast confirms an action whose result stays on the page, so it goes by itself after
 * `NOTICE_MS`, and carries no close control. **A presentation timer, not a business rule**: it clears the notice STATE the screen shows and
 * nothing else; the kit's own « a message that vanishes is a message somebody missed » stands for the kit at large.
 */
export const NOTICE_MS = 4200;

/** Clears `notice` (through `clear`) `NOTICE_MS` after it was set; a new notice restarts the clock, leaving the screen stops it. */
export function useNoticeTimer(notice: unknown, clear: () => void): void {
  useEffect(() => {
    if (notice === null || notice === undefined) return undefined;
    const gone = window.setTimeout(clear, NOTICE_MS);
    return () => {
      window.clearTimeout(gone);
    };
    // `clear` is a closure over a state setter: it is deliberately not a dependency (a new closure each render must not restart the clock).
  }, [notice]);
}
